import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { client } from "../../client";
import "./AllBlogs.scss";
import "./AllCategories.scss";
import { AppWrap } from "../../wrapper";
import { DotLoader } from "react-spinners";

const AllCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const categoryQuery =
      '*[_type == "category"]{title, slug, "count": count(*[_type == "blog" && references(^._id)])}';
    client.fetch(categoryQuery).then((data) => {
      setCategories(data);
      setLoading(false);
    });
  }, []);

  // Generate a random color for each category (memoized for stable color per session)
  const getRandomColor = (idx) => {
    const colors = [
      "#3498db",
      "#e67e22",
      "#2ecc71",
      "#e74c3c",
      "#9b59b6",
      "#1abc9c",
      "#f39c12",
      "#34495e",
      "#16a085",
      "#8e44ad",
      "#c0392b",
      "#27ae60",
      "#2980b9",
      "#d35400",
      "#7f8c8d",
      "#2c3e50",
    ];
    return colors[idx % colors.length];
  };

  return (
    <div className="app__all-blogs">
      <h2 className="head-text">
        All <span>Categories</span>
      </h2>
      {loading ? (
        <div className="loader-container">
          <DotLoader color="#3498db" size={50} />
        </div>
      ) : (
        <div
          className="categories-list all-categories-list"
          style={{ marginTop: "2rem" }}
        >
          {categories.length === 0 ? (
            <p>No categories found.</p>
          ) : (
            categories
              .sort((a, b) => b.count - a.count)
              .map((cat, idx) => (
                <Link
                  to={`/categories/${cat.slug?.current || cat.title}`}
                  className="category-item enhanced-category-item"
                  style={{ textDecoration: "none" }}
                  key={cat.slug?.current || cat.title}
                >
                  <span
                    className="category-title enhanced-category-title"
                    style={{ color: getRandomColor(idx) }}
                  >
                    {cat.title}
                  </span>
                  <span
                    className="category-count enhanced-category-count"
                    style={{ background: getRandomColor(idx) }}
                  >
                    {cat.count}
                  </span>
                </Link>
              ))
          )}
        </div>
      )}
    </div>
  );
};

export default AppWrap(AllCategories, "categories");
